import React from "react";
import StaticPage from "./StaticPage";
import { STATIC_PAGES } from "./staticPages";

const StaticPageRoute = ({ pageKey }) => {
  const page = STATIC_PAGES[pageKey];

  if (!page) {
    return null;
  }

  return (
    <StaticPage
      seo={page.seo}
      hero={page.hero}
      intro={page.intro}
      sections={page.sections}
      highlights={page.highlights}
      routes={page.routes}
      cta={page.cta}
    />
  );
};

export default StaticPageRoute;
